"use strict";

(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.mainMenu = {
    attach: function attach(context, settings) {
      var width = $(window).innerWidth();
      $('.menu-level-0 > .menu-item.menu-item--expanded').once('mainMenuButton').each(function () {
        $(this).prepend("<div class=\"expand\"></div>");
      });
      $('.menu-level-0 > .menu-item').once('mainMenu').on('mouseover', function () {
        width = $(window).innerWidth();
        if (width > 976) {
          var $subMenu = $(this).find('.menu-level-1');
          $subMenu.addClass('active');
          $(this).on('mouseleave', function () {
            $subMenu.removeClass('active');
          });
        }
      });
      $('.menu-level-0 > .menu-item').once('mainMenu').on('click', function () {
        width = $(window).innerWidth();
        if (width <= 976) {
          var $subMenu = $(this).find('.menu-level-1');
          $subMenu.addClass('active');
          $(this).on('mouseleave', function () {
            $subMenu.removeClass('active');
          });
        }
      });
      $('.menu-level-1 .menu-item > .expand').once('menuPlus').on('click', function () {
        $(this).toggleClass('active').parent().find('.menu-level-2').slideToggle();
      });
      $('.menu-level-0 > .menu-item > .expand').once('menuPlus').on('click', function () {
        width = $(window).innerWidth();
        if (width <= 976) {
          $(this).toggleClass('active').parent().find('.menu-level-1').slideToggle();
        }
      });
    }
  };
  Drupal.behaviors.mobileMenu = {
    attach: function attach(context, settings) {
      $('.navbar-toggler, #block-navigationprincipale-menu').once('mobileMenu').on('click', function () {
        var $button = $('.navbar-toggler .navbar-toggler-icon');
        var $menu = $('.menu-level-0');
        $button.toggleClass('active');
        $menu.toggleClass('active');
      });
    }
  };
})(jQuery, Drupal);